<template>
  <header class="header">
    <div class="w-header h-100 d-flex justify-content-between align-items-center">
      <div class="nav-left d-flex align-items-center">
        <div class="logo cursor-pointer">
          <img src="@/assets/images/login/login-logo.png" alt="" @click="goHome" />
        </div>
        <div class="nav-list d-flex align-items-center">
          <div :class="['nav-item', firstNavIndex == index ? 'active' : '']" v-for="(item, index) in navList" :key="index">
            <div class="cursor-pointer item-name first-level" @click="changeNav(item, index)">
              {{ item.name }}
            </div>
            <!-- 产品二级菜单 -->
            <div v-if="item.children && item.id == 'products'" class="nav-second products">
              <div class="hidden-block"></div>
              <div class="nav-second-list">
                <div class="stage-wrap d-flex">
                  <div class="select-stage">
                    {{ $t('message.header.stageText1') }}
                  </div>
                  <div class="stage-list d-flex">
                    <div
                      class="stage-item cursor-pointer"
                      :class="activeStage == index ? 'active' : ''"
                      @mouseover="onStageOver(index)"
                      v-for="(item, index) in stageData"
                      :key="index"
                    >
                      <img :src="item.icon" :class="item.imgClass" alt="" />
                      {{ item.label }}
                    </div>
                  </div>
                </div>
                <div class="nav-second-content d-flex">
                  <div class="nav-second-wrap" v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                    <div class="nav-second-item w-100">
                      <div>
                        <div class="item-name">
                          <span class="cursor-pointer" @click="changeNav(secondItem, index, secondIndex)">{{ secondItem.name }}</span>
                        </div>
                      </div>
                      <i class="el-icon-arrow-right nav-second-item-arrow" v-if="secondItem.children"></i>
                    </div>
                    <!-- 产品三级菜单 -->
                    <div class="nav-third" v-if="secondItem.children">
                      <div
                        v-for="(thirdItem, thirdIndex) in secondItem.children"
                        :key="thirdIndex"
                        class="nav-third-item d-flex align-items-center justify-content-between"
                        @mouseover="handleThirdHover(thirdItem)"
                        @mouseleave="handleThirdLeave"
                        :class="[thirdItem.class, selectPlatform.indexOf(thirdItem.platformIndex) > -1 ? 'active' : '']"
                      >
                        <div class="w-100 item-name d-flex align-items-center justify-content-between" @click="handleThirdClick(secondItem, thirdIndex)">
                          <div class="d-flex align-items-center">
                            <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                            <div class="text-wrap">
                              <div class="label">
                                {{ thirdItem.name }}
                              </div>
                              <div class="desc">
                                {{ thirdItem.desc }}
                              </div>
                            </div>
                          </div>
                          <div class="arrow-wrap">
                            <img class="arrow" v-if="hoverPlatform === thirdItem.platformIndex" src="@/assets/images/header/header-arrow.png" alt="" />
                          </div>
                        </div>
                        <!-- 产品四级菜单 -->
                        <div class="nav-third-item-children" v-if="thirdItem.children">
                          <div
                            v-for="(fourthItem, fourthIndex) in thirdItem.children"
                            :key="fourthIndex"
                            class="nav-third-item-children-item d-flex align-center"
                          >
                            <div class="mr-1">
                              <img :src="fourthItem.icon" alt="" />
                            </div>
                            <div class="cursor-pointer item-name">
                              {{ fourthItem.name }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 二级菜单-解决问题 -->
            <div v-if="item.children && item.id == 'problem'" class="nav-second problem">
              <div class="hidden-block"></div>
              <div class="nav-second-list problem">
                <div class="nav-second-content d-flex">
                  <div class="nav-second-wrap" v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                    <div class="nav-second-item w-100">
                      <div>
                        <div class="item-name">
                          <img class="second-item-icon" :src="secondItem.icon" alt="" />
                          <span class="cursor-pointer" @click="changeNav(secondItem, index, secondIndex)">{{ secondItem.name }}</span>
                        </div>
                      </div>
                      <i class="el-icon-arrow-right nav-second-item-arrow" v-if="secondItem.children"></i>
                    </div>
                    <!-- 产品三级菜单 -->
                    <div class="nav-third" v-if="secondItem.children">
                      <div
                        v-for="(thirdItem, thirdIndex) in secondItem.children"
                        :key="thirdIndex"
                        class="nav-third-item d-flex align-items-center justify-content-between"
                        :class="[thirdItem.class, selectPlatform.indexOf(thirdItem.platformIndex) > -1 ? 'active' : '']"
                      >
                        <div class="w-100 item-name d-flex align-items-center justify-content-between" @click="handleThirdClick(secondItem, thirdIndex)">
                          <div class="d-flex align-items-center label-wrap">
                            <div class="text-wrap">
                              <div class="label text-truncate" :title="thirdItem.name">
                                {{ thirdItem.name }}
                              </div>
                            </div>
                          </div>
                          <div class="arrow-wrap">
                            <img class="arrow" src="@/assets/images/header/header-arrow.png" alt="" />
                          </div>
                        </div>
                        <!-- 产品四级菜单 -->
                        <div class="nav-third-item-children" v-if="thirdItem.children">
                          <div
                            v-for="(fourthItem, fourthIndex) in thirdItem.children"
                            :key="fourthIndex"
                            class="nav-third-item-children-item d-flex align-center"
                          >
                            <div class="mr-1">
                              <img :src="fourthItem.icon" alt="" />
                            </div>
                            <div class="cursor-pointer item-name">
                              {{ fourthItem.name }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="nav-third-item more">
                        ......
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 关于我们 -->
            <div v-if="item.children && item.id == 'aboutFirst'" class="nav-second about">
              <div class="hidden-block"></div>
              <div class="nav-second-list">
                <div class="nav-second-item w-100"  v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                  <div>
                    <div class="item-name">
                      <span class="cursor-pointer" @click="changeNav(secondItem)">{{ secondItem.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 用户指南 -->
            <div v-if="item.children && item.id == 'docsFirst'" class="nav-second docs">
              <div class="hidden-block"></div>
              <div class="nav-second-list">
                <div class="nav-second-item w-100"  v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                  <div>
                    <div class="item-name">
                      <span class="cursor-pointer" @click="changeNav(secondItem)">{{ secondItem.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-language" style="display: none;">
        <!-- 中英文切换 -->
        <!-- <el-dropdown>
          <span class="loginBtn cursor-pointer">
            {{ currentLangLabel }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(lang, index) in langList" :key="index">
              <div @click="changeLanguage(lang)" class="cursor-pointer" :class="lang.code == currentLang ? 'active' : ''">
                {{ lang.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <div class="nav-list-mobile">
        <div class="icon-wrap">
          <img v-if="mobileMenuShow == false" @click="toggleMobileMenu" src="@/assets/images/menu.png" class="menu" alt="" />
          <img v-if="mobileMenuShow == true" @click="toggleMobileMenu" src="@/assets/images/menu-off.png" class="menu-off" alt="" />
        </div>
      </div>
      <div class="nav-right d-flex align-items-center">
        <div class="phone">
          <img src="@/assets/images/header/phone.svg" alt="" />
          +86 4000502885
        </div>
        <template>
          <div class="loginBtn cursor-pointer" @click="goLogin" v-if="!userName">
            <!-- 立即登录 -->
            {{ $t('message.header.loginBtn') }}
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="loginBtn cursor-pointer" @click="goLoginOut" v-else>
            <!-- 退出登录 -->
            <i class="el-icon-s-custom fs_16 mr-1"></i>
            {{ $t('message.header.loginOutBtn') }}
          </div>
        </template>
        <!-- 中英文切换 -->
        <!-- <el-dropdown>
          <span class="loginBtn cursor-pointer">
            {{ currentLangLabel }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(lang, index) in langList" :key="index">
              <div @click="changeLanguage(lang)" class="cursor-pointer" :class="lang.code == currentLang ? 'active' : ''">
                {{ lang.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
    <div class="mobile-menu" v-if="mobileMenuShow">
      <div :class="['nav-item', firstNavIndex == index ? 'active' : '']" v-for="(item, index) in navList" :key="index">
        <div class="cursor-pointer item-name" @click="changeNav(item, index)">
          {{ item.name }}
        </div>
        <!-- 产品二级菜单 -->
        <div v-if="item.children" class="nav-second">
          <div class="nav-second-list">
            <div v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
              <div
                class="nav-second-item cursor-pointer d-flex align-items-center justify-content-between drop_toggle"
                :class="[secondNavIndex == secondIndex ? 'active' : '', selectMenu == secondItem.name ? 'menu_arrow' : '']"
                @click="changeSecondMobile(secondItem, index, secondIndex)"
              >
                <div class="d-flex align-items-center">
                  <div class="item-name">
                    {{ secondItem.name }}
                  </div>
                </div>
                <i class="el-icon-arrow-down nav-second-item-arrow" v-if="secondItem.children"></i>
              </div>
              <el-collapse-transition>
                <div class="nav-third" v-if="secondItem.children && selectMenu == secondItem.name">
                  <div
                    v-for="(thirdItem, thirdIndex) in secondItem.children"
                    :key="thirdIndex"
                    class="nav-third-item"
                    :class="[
                      secondItem.id == 'developTools' && (thirdIndex == 1 || thirdIndex == 4) ? 'special' : '',
                      secondItem.id == 'supportTools' && (thirdIndex == 0 || thirdIndex == 2) ? 'special2' : '',
                      secondItem.id == 'supportTools' && (thirdIndex == 1 || thirdIndex == 3) ? 'special3' : '',
                    ]"
                  >
                    <div class="item-name" @click="handleThirdClick(secondItem, thirdIndex)">
                      {{ thirdItem.name }}
                    </div>
                    <!-- 产品四级菜单 -->
                    <div class="nav-third-item-children" v-if="thirdItem.children">
                      <div v-for="(fourthItem, fourthIndex) in thirdItem.children" :key="fourthIndex" class="nav-third-item-children-item d-flex align-center">
                        <div class="mr-1">
                          <img :src="fourthItem.icon" alt="" />
                        </div>
                        <div class="cursor-pointer item-name">
                          {{ fourthItem.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
              <!-- 产品三级菜单 -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: ['currentLang'],
  inject: ['changeAppLanguage'],
  data() {
    return {
      selectMenu: '',
      activeStage: -1,
      selectPlatform: [],
      hoverPlatform: '',
      stageData: [
        {
          label: this.$t('message.header.stageText2'),
          icon: require('@/assets/images/header/stage1.png'),
          imgClass: 'stage-icon0',
        },
        {
          label: this.$t('message.header.stageText3'),
          icon: require('@/assets/images/header/stage2.png'),
          imgClass: 'stage-icon1',
        },
        {
          label: this.$t('message.header.stageText4'),
          icon: require('@/assets/images/header/stage3.png'),
          imgClass: 'stage-icon2',
        },
        {
          label: this.$t('message.header.stageText5'),
          icon: require('@/assets/images/header/stage4.png'),
          imgClass: 'stage-icon3',
        },
        {
          label: this.$t('message.header.stageText6'),
          icon: require('@/assets/images/header/stage5.png'),
          imgClass: 'stage-icon4',
        },
        {
          label: this.$t('message.header.stageText7'),
          icon: require('@/assets/images/header/stage6.png'),
          imgClass: 'stage-icon5',
        },
        {
          label: this.$t('message.header.stageText8'),
          icon: require('@/assets/images/header/stage7.png'),
          imgClass: 'stage-icon6',
        },
      ],
      userName: localStorage.user_name,
      firstNavIndex: -1, // 当前选中的导航索引
      navList: [
        {
          id: 'problem',
          name: this.$t('message.index.text7'), // 我们解决什么问题
          routerPath: '',
          children: [
            {
              id: 'step1',
              icon: require('@/assets/images/header/header-icon7.png'),
              name: this.$t('message.index.text12'), // 获客阶段
              routerPath: '',
              pid: 'step1',
              children: [
                {
                  name: this.$t('message.index.text14'), // 适合自己的海外市场在哪里?
                  routerPath: '/problem-overseas-market',
                },
                {
                  name: this.$t('message.index.text19'), // 客户不搭理你该怎么办?
                  routerPath: '/problem-customer-respond',
                },
                {
                  name: this.$t('message.index.text15'), // 出国考察前要思考哪些问题?
                  routerPath: '/problem-overseas-inspection',
                },
                {
                  name: this.$t('message.index.text20'), // 如何高效联系大量客户?
                  routerPath: '/problem-customer-contact',
                },
                {
                  name: this.$t('message.index.text16'), // 如何找到目标客户？
                  routerPath: '/problem-target-customer',
                },
                {
                  name: this.$t('message.index.text21'), // 不懂外语怎么和客户沟通及开会?
                  routerPath: '/problem-communicate',
                },
                {
                  name: this.$t('message.index.text17'), // 如何低成本出海?
                  routerPath: '/problem-low-cost',
                },
                {
                  name: this.$t('message.index.text22'), // 对海外某个客户不了解怎么办?
                  routerPath: '/problem-customer-inform',
                },
                {
                  name: this.$t('message.index.text18'), // 国内团队能否做海外市场？
                  routerPath: '/problem-domestic-team',
                },
              ],
            },
            {
              id: 'step2',
              icon: require('@/assets/images/header/header-icon10.png'),
              name: this.$t('message.index.text13'), // 商机转化阶段
              routerPath: '',
              pid: 'step2',
              children: [
                {
                  name: this.$t('message.index.text31'), // 客户需求不清晰怎么办?
                  routerPath: '/problem-unclear-demand',
                },
                {
                  name: this.$t('message.index.text27'), // 如何减少商机转化的差旅成本?
                  routerPath: '/problem-travel-expenses',
                },
                {
                  name: this.$t('message.index.text23'), // 海外新人或者合作伙伴如何快速掌握业务?
                  routerPath: '/problem-business-mastery',
                },
                {
                  name: this.$t('message.index.text28'), // 海外产品演示成本过高怎么办?
                  routerPath: '/problem-demonstrate-cost',
                },
                {
                  name: this.$t('message.index.text24'), // 如何快速建立海外客户对你的专业印象?
                  routerPath: '/problem-major-impression',
                },
                {
                  name: this.$t('message.index.text29'), // 商机推进不下去了怎么办?
                  routerPath: '/problem-business-promote',
                },
                {
                  name: this.$t('message.index.text25'), // 遇到海外客户的挑战/质疑如何应对?
                  routerPath: '/problem-challenge-respond',
                },
                {
                  name: this.$t('message.index.text30'), // 遇到竞争对手冲击怎么办?
                  routerPath: '/problem-opponent-impact',
                },
                {
                  name: this.$t('message.index.text26'), // 如何高效应对多个客户的产品/方案需求?
                  routerPath: '/problem-efficient-response',
                },
              ],
            },
          ],
        },
        {
          id: 'services',
          name: this.$t('message.index.text11'), // 代运营服务
          routerPath: '/Services',
        },
        {
          id: 'products',
          name: 'AI工具',
          routerPath: '',
          children: [
            {
              id: 'developTools',
              icon: require('@/assets/images/header/product-icon8.png'),
              name: this.$t('message.index.text9'), // 获客工具
              routerPath: '/tools?activeIndex=0',
              pid: 'procucts',
              children: [
                {
                  platformIndex: 0,
                  name: this.$t('message.header.navList[0].children[1].children[0].name'), // 市场分析
                  icon: require('@/assets/images/header/header-icon1.png'),
                  desc: this.$t('message.header.navList[0].children[1].children[0].desc'),
                  routerPath: '/marketAnalytics',
                  imgClass: 'third-icon0',
                },
                {
                  platformIndex: 1,
                  name: this.$t('message.header.navList[0].children[1].children[1].name'), // 全球获客
                  icon: require('@/assets/images/header/header-icon2.png'),
                  desc: this.$t('message.header.navList[0].children[1].children[1].desc'),
                  routerPath: '/globalCustomer',
                  imgClass: 'third-icon1',
                },
                {
                  platformIndex: 2,
                  name: this.$t('message.header.navList[0].children[1].children[2].name'), // 客户洞察
                  icon: require('@/assets/images/header/header-icon3.png'),
                  desc: this.$t('message.header.navList[0].children[1].children[2].desc'),
                  routerPath: '/customerInsights',
                  imgClass: 'third-icon2',
                },
                {
                  platformIndex: 5,
                  name: this.$t('message.index.text2'), // 智能拓客邮件
                  icon: require('@/assets/images/header/header-icon6.png'),
                  desc: this.$t('message.header.navList[0].children[1].children[5].desc'),
                  routerPath: '/smartEmail',
                  imgClass: 'third-icon5',
                },
                {
                  platformIndex: 4,
                  name: this.$t('message.index.text3'), // 邮件策略助手
                  icon: require('@/assets/images/header/header-icon5.png'),
                  desc: this.$t('message.header.navList[0].children[1].children[6].desc'),
                  routerPath: '/emailStrategy',
                  imgClass: 'third-icon4',
                },
                {
                  platformIndex: 3,
                  name: this.$t('message.header.navList[0].children[1].children[3].name'), // 图文海报制作
                  icon: require('@/assets/images/header/header-icon4.png'),
                  desc: this.$t('message.header.navList[0].children[1].children[3].desc'),
                  routerPath: '/smartPoster',
                  imgClass: 'third-icon3',
                },
              ],
            },
            {
              id: 'supportTools',
              icon: require('@/assets/images/header/product-icon9.png'),
              name: this.$t('message.index.text10'), // 商机转化工具
              routerPath: '/tools?activeIndex2=0',
              pid: 'procucts',
              children: [
                {
                  platformIndex: 6,
                  name: this.$t('message.index.text4'), // 产品宣传页制作
                  icon: require('@/assets/images/header/header-icon7.png'),
                  desc: this.$t('message.index.text6'),
                  routerPath: '/productPopularize',
                  imgClass: 'third-icon6',
                },
                {
                  platformIndex: 6,
                  name: this.$t('message.header.navList[0].children[1].children[6].name'), // 困境策略大师
                  icon: require('@/assets/images/header/header-icon7.png'),
                  desc: this.$t('message.header.navList[0].children[1].children[6].desc'),
                  routerPath: '/strategyCoach',
                  imgClass: 'third-icon6',
                },
                {
                  platformIndex: 7,
                  name: this.$t('message.header.navList[0].children[2].children[0].children[0].name'), // 痛点挖掘专家
                  icon: require('@/assets/images/header/header-icon8.png'),
                  desc: this.$t('message.header.navList[0].children[2].children[0].children[0].desc'),
                  routerPath: '/painPoints',
                  imgClass: 'third-icon7',
                },
                {
                  platformIndex: 8,
                  name: this.$t('message.header.navList[0].children[2].children[0].children[2].name'), // 解决方案生成平台
                  icon: require('@/assets/images/header/header-icon9.png'),
                  desc: this.$t('message.header.navList[0].children[2].children[0].children[1].desc'),
                  routerPath: '/solutionGenerationPlatform',
                  imgClass: 'third-icon8',
                },
                {
                  platformIndex: 9,
                  name: this.$t('message.header.navList[0].children[2].children[0].children[1].name'), // 运营模拟分析平台
                  icon: require('@/assets/images/header/header-icon10.png'),
                  desc: this.$t('message.header.navList[0].children[2].children[0].children[2].desc'),
                  routerPath: '/simulation',
                  imgClass: 'third-icon9',
                },
                {
                  platformIndex: 10,
                  name: this.$t('message.header.navList[0].children[2].children[0].children[3].name'), // Demo及培训平台
                  icon: require('@/assets/images/header/header-icon11.png'),
                  desc: this.$t('message.header.navList[0].children[2].children[0].children[3].desc'),
                  routerPath: '/training',
                  imgClass: 'third-icon10',
                },
              ],
            },
            {
              id: 'contactTools',
              icon: require('@/assets/images/header/product-icon9.png'),
              name: 'AI智能翻译及策略沟通', //
              routerPath: '',
              pid: 'contactTools',
              children: [
                {
                  platformIndex: 4,
                  name: this.$t('message.header.navList[0].children[1].children[4].name'), // 语音同传及策略沟通助手
                  icon: require('@/assets/images/header/header-icon8.png'),
                  desc: this.$t('message.header.navList[0].children[2].children[0].children[0].desc'),
                  routerPath: '/speechTranslator',
                  imgClass: 'third-icon7',
                },
                {
                  platformIndex: 11,
                  name: 'AI PPT智能翻译', //
                  icon: require('@/assets/images/header/header-icon9.png'),
                  desc: '多语翻译·格式无损·专业高效',
                  routerPath: '/AI_Translation',
                  imgClass: 'third-icon8',
                },
              ],
            },
          ],
        },
        {
          id: 'robot',
          name: '机器人员工',
          routerPath: '/Robot',
        },
        {
          id: 'aboutFirst',
          name: this.$t('message.header.navList[1].name'), // 关于我们
          routerPath: '',
          children: [
            {
              id: 'about',
              name: this.$t('message.header.navList[1].name'), // 获客工具
              routerPath: '/about',
            },
            {
              id: 'contact',
              name: this.$t('message.header.navList[2].name'), // 联系我们
              routerPath: '/contact',
            },
          ],
        },
        {
          id: 'docsFirst',
          name: this.$t('message.header.docs'), // 文档
          routerPath: '',
          children: [
            {
              id: 'docs',
              name: this.$t('message.header.docs'), // 文档
              routerPath: '',
            },
            {
              id: 'faq',
              name: 'FAQ', // 文档
              routerPath: '/faq',
            },
          ],
        },
        // {
        //   id: 'contact',
        //   name: this.$t('message.header.navList[2].name'), // 联系我们,
        //   routerPath: '/contact',
        // },
        // {
        //   id: 'docs',
        //   name: this.$t('message.header.docs'), // 文档
        //   routerPath: '',
        // },
        // {
        //   id: 'faq',
        //   name: 'FAQ', // 文档
        //   routerPath: '/faq',
        // },
      ],
      secondNavIndex: -1, // 二级导航索引
      langList: [
        {
          code: 'cn',
          label: '简体中文',
        },
        {
          code: 'en',
          label: 'English',
        },
      ],
      currentLangLabel: '',
      hostName: '',
      mobileMenuShow: false,
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        // console.log('参数变化:', to);
        localStorage.setItem('firstNavIndex', to.meta.index);
        this.$nextTick(() => {
          this.firstNavIndex = localStorage.getItem('firstNavIndex') || -1;
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.hostName = location.host.substring(location.host.lastIndexOf('.'));
    this.currentLangLabel = this.langList.find(item => item.code == this.currentLang).label || '简体中文';
    this.secondNavIndex = localStorage.getItem('secondNavIndex') || -1;
    if (this.$route.path == '/') {
      localStorage.setItem('firstNavIndex', -1);
    }
    this.$nextTick(() => {
      this.firstNavIndex = localStorage.getItem('firstNavIndex') || -1;
    });
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuShow = !this.mobileMenuShow;
    },
    changeFirstNavIndex(index) {
      this.firstNavIndex = index;
    },
    // 跳转首页
    goHome() {
      this.firstNavIndex = -1;
      this.secondNavIndex = -1;
      localStorage.removeItem('firstNavIndex');
      localStorage.removeItem('secondNavIndex');
      this.$router.push('/');
    },

    // 中英文切换
    changeLanguage(lang) {
      // return;
      this.currentLangLabel = this.langList.find(item => item.code == lang.code).label || '简体中文';
      this.changeAppLanguage(lang.code);
    },

    // 登录
    goLogin() {
      window.location.href =
        process.env.NODE_ENV === 'development'
          ? `https://user.xpirory.cn/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`
          : `https://user.xpirory.cn/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`;
      // this.$router.push('/contact');
      localStorage.clear();
    },

    // 退出登录
    goLoginOut() {
      this.$confirm(this.$t('message.index.logoutTips'), this.$t('message.tips'), {
        type: 'warning',
      }).then(() => {
        this.$message.success(this.$t('message.index.logoutSuccess'));
        localStorage.clear();
      });
    },

    // 导航
    changeNav(item, index, secondIndex) {
      if (item.id == 'docs') {
        this.goLogin();
        return;
      }
      if (item.id == 'procucts') {
        return;
      }

      if (!item.routerPath) return;

      this.firstNavIndex = index;
      localStorage.setItem('firstNavIndex', index);
      if (secondIndex !== undefined) {
        this.secondNavIndex = secondIndex;
        localStorage.setItem('secondNavIndex', secondIndex);
      } else {
        this.secondNavIndex = -1;
        localStorage.setItem('secondNavIndex', -1);
      }
      if (item.routerPath) {
        this.$router.push(item.routerPath);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      this.mobileMenuShow = false;
    },

    changeSecondMobile(item, index, secondIndex) {
      if (item.name == this.selectMenu) {
        this.selectMenu = '';
        return;
      }
      this.selectMenu = item.name;
    },

    onStageOver(index) {
      this.activeStage = index;
      this.selectPlatform = [];
      if (index == 0) {
        this.selectPlatform = [0];
      } else if (index == 1) {
        this.selectPlatform = [1, 2];
      } else if (index == 2) {
        this.selectPlatform = [3, 5, 6];
      } else if (index == 3) {
        this.selectPlatform = [4, 11];
      } else if (index == 4) {
        this.selectPlatform = [7, 9];
      } else if (index == 5) {
        this.selectPlatform = [8, 11];
      } else if (index == 6) {
        this.selectPlatform = [9, 10];
      }
    },
    // 鼠标移入
    onSecondMouseOver(index) {
      this.secondNavIndex = index;
    },
    handleThirdHover(thirdItem) {
      this.hoverPlatform = thirdItem.platformIndex;
      if (thirdItem.platformIndex == 0) {
        this.activeStage = 0;
      } else if (thirdItem.platformIndex == 1 || thirdItem.platformIndex == 2) {
        this.activeStage = 1;
      } else if (thirdItem.platformIndex == 3 || thirdItem.platformIndex == 5 || thirdItem.platformIndex == 6) {
        this.activeStage = 2;
      } else if (thirdItem.platformIndex == 4 || thirdItem.platformIndex == 11) {
        this.activeStage = 3;
      } else if (thirdItem.platformIndex == 7 || thirdItem.platformIndex == 9) {
        this.activeStage = 4;
      } else if (thirdItem.platformIndex == 8) {
        this.activeStage = 5;
      } else if (thirdItem.platformIndex == 9 || thirdItem.platformIndex == 10) {
        this.activeStage = 6;
      }

      if (this.activeStage == 0) {
        this.selectPlatform = [0];
      } else if (this.activeStage == 1) {
        this.selectPlatform = [1, 2];
      } else if (this.activeStage == 2) {
        this.selectPlatform = [3, 5, 6];
      } else if (this.activeStage == 3) {
        this.selectPlatform = [4, 11];
      } else if (this.activeStage == 4) {
        this.selectPlatform = [7, 9];
      } else if (this.activeStage == 5) {
        this.selectPlatform = [8];
      } else if (this.activeStage == 6) {
        this.selectPlatform = [9, 10];
      }
    },
    handleThirdLeave() {
      this.hoverPlatform = '';
    },
    // 三级目录点击
    handleThirdClick(item, index) {
      if (!item.children[index].routerPath) return;
      this.$router.push(`${item.children[index].routerPath}`);
      if (item.children[index].routerPath.indexOf('/tools') < 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      this.mobileMenuShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-header {
  width: 85%;
  margin: 0 auto;
}

.hidden-block {
  height: 10px;
  background: transparent;
}

.header {
  height: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 14px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000; /* 确保头部层级最高 */
  background: #0c0c0d;

  .logo img {
    height: 20px;
  }

  .nav-left {
    position: relative;

    .nav-list {
      margin-left: 160px;

      .nav-item {
        position: relative;

        > .item-name {
          font-size: 1rem;
          font-weight: 600;
          text-align: center;
          height: 60px;
          line-height: 60px;
          width: 90px;
          margin-right: 60px;
          color: rgba(255, 255, 255, 0.5);
          box-sizing: border-box;
        }
      }
      .nav-item:first-child {
        .item-name.first-level {
          width: 145px;
        }
      }

      .nav-item:nth-child(6) {
        .item-name.first-level {
          margin-right: 45px;
        }
      }

      .nav-item.active > .item-name,
      .nav-item:hover > .item-name {
        color: var(--text-color);
        border-bottom: 2px solid var(--primary-color);
      }

      .nav-second {
        display: none;
        z-index: 9999;
        position: absolute;
        top: 55px;
        left: -720px;
        &.problem {
          .nav-second-item {
            .item-name {
              text-align: left;
            }
          }
        }

        &.about {
          left: -40px;
          .nav-second-list {
            width: 170px;
            padding-top: 30px;
            padding-bottom: 16px;
            .nav-second-item {
              font-size: 12px;
              .item-name {
                font-weight: normal;
                color: rgba(255, 255, 255, 0.6);
                span {
                  font-size: 16px;
                }
              }
              .item-name:hover {
                color: #fff;
                transition: all .3s;
              }
            }
          }
        }

        &.docs {
          left: -40px;
          .nav-second-list {
            width: 170px;
            padding-top: 30px;
            padding-bottom: 16px;
            .nav-second-item {
              text-align: left;
              padding-left: 60px;
              .item-name {
                color: rgba(255, 255, 255, 0.6);
                font-weight: normal;
                span {
                  font-size: 16px;
                }
              }
              .item-name:hover {
                color: #fff;
                transition: all .3s;
              }
            }
          }
        }

        .stage-wrap {
          border-bottom: 1px solid #333c47;
          background: #263444;
          .select-stage {
            padding: 10px 28px;
            border-radius: 6px;
            background: var(--primary-color);
          }
          .stage-list {
            align-items: center;
            .stage-item {
              margin-left: 26px;
              margin-right: 40px;
              font-size: 16px;
              height: 22px;
              color: rgba(255, 255, 255, 0.6);
              position: relative;
              img {
                margin-right: 3px;
              }
              .stage-icon0 {
                width: 24px;
              }
              .stage-icon1 {
                width: 17px;
              }
              .stage-icon2 {
                width: 21px;
              }
              .stage-icon3 {
                width: 19px;
              }
              .stage-icon4 {
                width: 20px;
              }
              .stage-icon5 {
                width: 19px;
              }
              .stage-icon6 {
                width: 22px;
              }
              &.active {
                color: #fff;
                &::after {
                  content: '';
                  display: block;
                  position: absolute;
                  bottom: -10px;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: var(--primary-color);
                }
              }
            }
          }
        }

        .nav-second-content {
          margin-top: 25px;
          .nav-second-wrap:nth-child(1) {
            width: 38%;
            border-right: 1px solid #555d65;
            .nav-third {
              padding-right: 35px;
            }
          }
          .nav-second-wrap:nth-child(2) {
            width: 44%;
            border-right: 1px solid #555d65;
            .nav-third {
              padding-right: 35px;
              .nav-third-item {
                width: 49%;
              }
            }
          }
          .nav-second-wrap:nth-child(3) {
            width: 24%;
            .nav-third {
              padding-right: 35px;
              justify-content: center;
              .nav-third-item {
                width: 90%;
              }
            }
          }
        }

        .nav-second-list {
          width: 1652px;
          background: url('@/assets/images/header/nav-second-list-bg.png') no-repeat;
          background-size: cover;
          border-radius: 6px;
          text-align: left;
          color: #fff;
          padding-bottom: 25px;
        }

        .nav-second-list * {
          line-height: normal;
          font-size: 15px;

          img {
            vertical-align: middle;
          }
        }

        &.problem {
          left: -250px;
          .nav-second-content {
            margin-top: 0 !important;
          }
          .nav-second-wrap {
            width: 50% !important;
            border: none !important;
            .nav-second-item {
              .item-name {
                border-bottom: 1px solid #333c47;
                padding: 15px 0 10px;
                padding-left: 65px;
              }
            }
          }
          .nav-third {
            .nav-third-item {
              .arrow-wrap {
                img {
                  opacity: 0;
                }
              }
              &:hover {
                background: #373f4a;
                color: #fff;
                .arrow-wrap {
                  img {
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }

      .nav-item:hover .nav-second {
        display: block;
        /* 添加标准属性 */
        animation-name: fadeIn 0.25s forwards;
      }

      .nav-second-item {
        text-align: center;

        .item-name {
          // padding-left: 65px;
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 25px;
          .second-item-icon {
            height: 26px;
            margin-right: 6px;
          }
          span {
            font-size: 18px;
          }
        }

        .nav-second-item-arrow {
          display: none;
        }
      }

      .nav-third {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        padding-left: 35px;
        /* 添加标准属性 */
        animation-name: fadeIn;
        animation-duration: 0.25s;
        animation-iteration-count: 1;
        animation-delay: 0s;
        .more {
          padding-left: 35px;
          color: rgba(255, 255, 255, 0.6);
          pointer-events: none;
        }
      }

      .nav-third-item {
        width: 48.33%;
        // margin-right: 1%;
        margin-bottom: 12px;
        padding: 8px 8px 8px 22px;
        box-sizing: border-box;
        border-radius: 36px;
        color: rgba(255, 255, 255, 0.6);
        &.long {
          width: 38%;
        }
        &.active {
          background: #373f4a;
          color: #fff;
        }
        .third-icon0 {
          width: 35px;
        }
        .third-icon1 {
          width: 40px;
        }
        .third-icon2 {
          width: 45px;
        }
        .third-icon3 {
          width: 33px;
        }
        .third-icon4 {
          width: 38px;
        }
        .third-icon5 {
          width: 36px;
        }
        .third-icon6 {
          width: 36px;
        }
        .third-icon7 {
          width: 38px;
        }
        .third-icon8 {
          width: 36px;
        }
        .third-icon9 {
          width: 44px;
        }
        .third-icon10 {
          width: 38px;
        }
        .arrow-wrap {
          width: 19px;
          .arrow {
            width: 19px;
          }
        }

        .item-name {
          cursor: pointer;
          transition: color 0.3s;
          .label-wrap {
            width: 96%;
          }
          .text-wrap {
            margin: 0 10px;
            width: 97%;
            .label {
              width: 100%;
              font-size: 16px;
            }
            .desc {
              margin-top: 8px;
              font-size: 12px;
            }
          }
        }

        .nav-third-item-children-item {
          font-size: 13px;
          margin-top: 10px;

          .item-name {
            font-size: 13px;
          }
        }

        .nav-third-item-children-item:hover {
          color: var(--primary-color);
        }
      }
    }
  }

  .nav-right {
    .phone {
      margin-right: 20px;
      img {
        height: 16px;
        margin-right: 2px;
      }
    }

    .loginBtn {
      font-size: 14px;
      width: 100px;
      text-align: center;
      height: 32px;
      line-height: 32px;
    }

    .el-dropdown {
      color: var(--text-color);
    }
  }
}
.en-container {
  .header .nav-left .nav-list .nav-item > .item-name {
    width: auto;
  }
  .header {
    .nav-left {
      .nav-list {
        .nav-second {
          .stage-wrap {
            .select-stage {
              padding-top: 12px;
              padding-bottom: 12px;
            }
            .stage-list {
              .stage-item {
                margin-right: 30px;
              }
            }
          }
          .nav-second-list {
            width: 1600px;
          }
        }
        .nav-third {
          padding-left: 20px;
        }
      }
    }
  }
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:has(.active) {
  background-color: #ecf5ff;
  color: var(--primary-color);
}

.drop_toggle {
  i.el-icon-arrow-down {
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
  }
  &.menu_arrow i.el-icon-arrow-down {
    -webkit-transform: rotateZ(180deg);
    transform: rotateZ(180deg);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    /*初始状态 透明度为0*/
  }

  20% {
    opacity: 0.2;
  }

  50% {
    opacity: 0.5;
    /*中间状态 透明度为0.5*/
  }

  70% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
    /*结尾状态 透明度为1*/
  }
}
.nav-list-mobile {
  display: none;
  float: right;
  .icon-wrap {
    .menu {
      width: 100px;
    }
    .menu-off {
      width: 60px;
    }
  }
}
.mobile-menu {
  position: absolute;
  top: 200px;
  right: 0;
  left: 0;
  bottom: 0;
  background: #000;
  padding: 3rem 0;
  padding-bottom: 180px;
  height: calc(100vh - 200px);
  overflow-y: auto;
  z-index: 999999;
  .nav-item {
    .item-name {
      font-size: 80px;
      padding: 75px 3rem;
      border-bottom: 1px solid #272424;
    }
  }
  .nav-second-item {
    padding-right: 50px;
    border-bottom: 1px solid #272424;
    & > div {
      width: 100%;
    }
    .nav-second-item-arrow {
      font-size: 66px;
    }
    .item-name {
      text-indent: 1em;
      width: 100%;
      border: none;
    }
  }
  .nav-third-item {
    width: 100% !important;
    background: #151515;
    .item-name {
      text-indent: 2em;
    }
  }
}
</style>
